export default __webpack_public_path__ + "static/media/darktemplarhead.48488874.png";